export enum EBusinessUserPermissionCode {
  ADD_BUSINESS_USER = 'ADD_BUSINESS_USER',
  REMOVE_BUSINESS_USER = 'REMOVE_BUSINESS_USER',
  APPROVE_BUSINESS_USER_REQUEST = 'APPROVE_BUSINESS_USER_REQUEST',
  REJECT_BUSINESS_USER_REQUEST = 'REJECT_BUSINESS_USER_REQUEST',
  APPLY_FOR_SERVICE = 'APPLY_FOR_SERVICE',
  PAY_FOR_SERVICE = 'PAY_FOR_SERVICE',
  VIEW_APPLICATIONS = 'VIEW_APPLICATIONS',
  VIEW_APPLICATION_DETAILS = 'VIEW_APPLICATION_DETAILS',
  VIEW_CERTIFICATES = 'VIEW_CERTIFICATES',
  DOWNLOAD_CERTIFICATE = 'DOWNLOAD_CERTIFICATE',
}

export interface IBaseBusinessPermissionAndGroupEntity {
  guid: string;
  code: string;
  label: string;
  description: string;
}

export enum EBusinessUserPermissionGroupCode {
  ADMIN = 'BUSINESS_ADMIN',
  OPERATOR = 'BUSINESS_OPERATOR',
}

export enum EBusinessUserRequestStatus {
  CREATED = 'CREATED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum EBusinessUserRequestActionType {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
}
